import { Checkbox, Flex, FormControl, Heading } from '@chakra-ui/react';
import React from 'react';
import type { FieldPath } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { extraServicesNeeded } from '../../constants';
import type { IShippingFormFields } from '../../types';
import { CustomCheckboxIcon } from './CustomCheckboxIcon';
import { PopoverInfo } from '../shared';

export const ExtraServices: React.FC = (): JSX.Element => {
  const { register } = useFormContext<IShippingFormFields>();
  const { t } = useTranslation();

  return (
    <Flex flexDirection="column">
      <Heading fontSize="large" fontWeight="bold" mb={4}>
        {t('FORM.EXTRA_SERVICES_TITLE')}
      </Heading>
      {extraServicesNeeded.map((es) => {
        const id = `extraServices.${es.id}` as FieldPath<IShippingFormFields>;
        return (
          <FormControl key={id}>
            <Checkbox
              icon={<CustomCheckboxIcon />}
              id={id}
              mb={4}
              spacing={4}
              variant="mbe"
              {...register(id)}
            >
              {t(es.label)}
            </Checkbox>
            {es.hasInfo && <PopoverInfo />}
          </FormControl>
        );
      })}
    </Flex>
  );
};
